import { CancelledError } from '@tanstack/react-query'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { HTTPError } from 'ky'
import { getOrderQueryOptions } from '#entities/order'

export const Route = createFileRoute(
  '/staff/_post-registration-required/_confirmation-required/orders/$id',
)({
  loader: async ({ params, context }) => {
    const { queryClient } = context

    try {
      await queryClient.ensureQueryData(getOrderQueryOptions(params.id))
    } catch (error: unknown) {
      if (error instanceof CancelledError) return

      if (error instanceof HTTPError) {
        if (error.response.status === 404) {
          throw notFound()
        }
      }

      throw error
    }
  },
})
